// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"bbf2d083","453":"fdf24dac","918":"503075cc"}[chunkId] + ".chunk.js";
};